

























import vue, {PropType} from 'vue';
import InstructionModel from '@/models/instruction.model';
import AnswerModel from '@/models/answer.model';
import Message from '@/components/messages/Message.vue';
import ChatMessageModel from '@/models/chat-message.model';
import createChatStream from '@/factories/chat-stream.factory';
import ChatMessage from '@/components/chat/ChatMessage.vue';
import features from '@/helpers/features';

export default vue.extend({
    components: {
        ChatMessage,
        Message,
    },
    props: {
        instructions: {
            type: Array as PropType<InstructionModel[]>,
            required: true,
        },
        answers: {
            type: Array as PropType<AnswerModel[]>,
            required: true,
        },
    },
    watch: {
        messages(stream: ChatMessageModel[]): void {
            this.$emit('messages', stream);
        },
    },
    data() {
        return {
            language: 'nl',
        };
    },
    computed: {
        messages(): ChatMessageModel[] {
            return createChatStream(
                this.instructions,
                this.answers,
                this.$i18n.locale,
            );
        },
        streamAnimations(): Array<string> {
            const animations = ['fade', 'scale'];
            const {canAnimateHeight} = features;

            if (canAnimateHeight) {
                animations.push('grow');
            }

            return animations;
        },
        streamStyle(): object {
            const {streamAnimations} = this;

            return {
                '--stream-animation': streamAnimations.join(', '),
                direction: this.languageIsRightToLeft ? 'rtl' : null,
            };
        },
        languageIsRightToLeft(): boolean {
            return this.language === 'ar';
        },
    },
    beforeMount() {
        const queryParam = this.$route.query?.l;
        const queryLanguage: string = Array.isArray(queryParam) ? (queryParam[0] || '') : (queryParam || '');

        const isValidLanguageCode = (code: string) => /^[a-z]{2}(-[A-Z]{2})?$/.test(code);

        const language: string = isValidLanguageCode(queryLanguage) ? queryLanguage : 'nl';

        if (!isValidLanguageCode(language)) {
            console.warn('Invalid language code:', language);
            return; // Or handle the validation case appropriately
        }

        this.language = language;
    },
    methods: {
        onAnimationStart(): void {
            this.$emit('animation-start');
        },
        onAnimationEnd(): void {
            this.$emit('animation-end');
        },
        isLatest(message: ChatMessageModel): boolean {
            const {messages: stream} = this;
            return message.uuid === stream[stream.length - 1].uuid;
        },
    },
});
